import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { DialogContent, DialogActions } from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useSnackbarContext } from 'Context/SnackbarContext';

const FeatureToggleLayout = () => {
  const {
    onSubmit, saving, resource, handleChange,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleContinue = async () => {
    try {
      await onSubmit({ rejectOnError: true });
      clearModalCollection();
    } catch (err) {
      displayErrorMessage(err, err?.errors || 'Invalid feature toggle configuration');
    }
  };

  return (
    <>
      <MetaControlField attr="name" />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={1}>
          <MetaControlField attr="description" />
          <MetaControlField attr="enabled" />
          <MetaControlField attr="activationStrategy" />
          <MetaControlField attr="enabledFor" />
          <MetaControlField attr="groupName" />
          <MetaControlField attr="parentToggle" />
          <MetaControlField attr="randomDistributionEnabled" />
          <MetaControlField attr="percentClientsEnabled" />
          <MetaControlField
            attr="randomHouseholdDistributions"
            CustomProps={{
              prompt: resource.metaField('randomHouseholdDistributions').attr('prompt'),
              setCollection(distributions) {
                handleChange('randomHouseholdDistributions', distributions);
              },
            }}
          />
          <MetaLayoutRemainingFields />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.meta().canSubmit() ? <FDPrimaryActionButton {...dataAttrs('continue-btn', resource)} label="Continue" onClick={handleContinue} disabled={saving} /> : null}
      </DialogActions>
    </>
  );
};

FeatureToggleLayout.defaultProps = {
};

FeatureToggleLayout.propTypes = {
};

export default FeatureToggleLayout;
